import { mCustomCiphers } from './mGameCustomCiphers';
import { passCodes } from './passCodes';
import annabeth from '../../../assets/images/games/m-game/percy/AnnabethChase.webp';
import bridget1 from '../../../assets/images/games/m-game/bridget1.gif';
import bridget2 from '../../../assets/images/games/m-game/bridget2.webp';
import bucky1 from '../../../assets/images/games/m-game/ws1.gif';
import door from '../../../assets/images/games/m-game/percy/door.webp';
import dwarvish from '../../../assets/images/games/m-game/Dwarvish.webp';
import explosion from '../../../assets/images/games/m-game/explosion.gif';
import frank from '../../../assets/images/games/m-game/percy/FrankZhang.webp';
import geographer from '../../../assets/images/games/m-game/zemepisec.webp';
import geryon from '../../../assets/images/games/m-game/percy/geryon.webp';
import grover from '../../../assets/images/games/m-game/percy/GroverUnderwood.webp';
import hades from '../../../assets/images/games/m-game/percy/hades.webp';
import hazel from '../../../assets/images/games/m-game/percy/HazelLevesque.webp';
import hedge from '../../../assets/images/games/m-game/percy/coach-hedge.webp';
import janus from '../../../assets/images/games/m-game/percy/janus.webp';
import jason from '../../../assets/images/games/m-game/percy/jason.webp';
import jost from '../../../assets/images/games/m-game/jost2.webp';
import kalypso from '../../../assets/images/games/m-game/percy/Calypso.webp';
import leo from '../../../assets/images/games/m-game/percy/Leo.webp';
import lotrcipher from '../../../assets/images/games/m-game/lotrcipher.webp';
import meduza from '../../../assets/images/games/m-game/percy/meduza.webp';
import neville1 from '../../../assets/images/games/m-game/neville1.webp';
import nico from '../../../assets/images/games/m-game/percy/NicoDiAngelo.webp';
import ohno from '../../../assets/images/games/m-game/ohno.webp';
import path1 from '../../../assets/images/games/m-game/path1.webp';
import path2 from '../../../assets/images/games/m-game/path2.webp';
import path3 from '../../../assets/images/games/m-game/path3.webp';
import path4 from '../../../assets/images/games/m-game/path4.webp';
import path5 from '../../../assets/images/games/m-game/path5.webp';
import percy from '../../../assets/images/games/m-game/percy/PercyJackson.webp';
import piper from '../../../assets/images/games/m-game/percy/PiperMcLean.webp';
import prince from '../../../assets/images/games/m-game/prince.webp';
import saruman from '../../../assets/images/games/m-game/saruman.webp';
import sphinx from '../../../assets/images/games/m-game/percy/sphinx.webp';
import tyson from '../../../assets/images/games/m-game/percy/Tyson.webp';
import wall1 from '../../../assets/images/games/m-game/wall.webp';
import wine from '../../../assets/images/games/m-game/wine.webp';

export const step1intro = {
    id: 1,
    continueButtonText: 'Rozumiem',
    title: 'Ahoj',
    taskText: `
        <p>Toto je špeciálne zariadenie, ktorým sa s tebou Hans a Pusheen dorozumievajú, ak to čo chcú povedať nevedia vyjadriť v kúzelnom denníku.</p>
        <p>Ak v denníku uvidíš symbol telefónu, pokračuj práve sem. Naopak, ak ti toto zariadenie ukáže symbol denníka, pokračuj tam.</p>
    `,
};

export const step2jost = {
    id: 2,
    taskText: `
        <p>Zadaj meno muža na koni, o ktorom píšu Hans a Pusheen.</p>
        <p>Ak vieš o koho ide, vydaj sa k nemu.</p>
        <p>Tu je malá nápoveda:</p>
    `,
    cipher: {
        images: [jost],
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[0],
    diaryIcon: true,
};

export const step3saruman = {
    id: 3,
    title: 'Miesto na kúzlo',
    taskText: `
        <p>Vtom sa zničohonič objavil čarodejník, o ktorom Pusheen hovorila, prekvapil stráž a zakričal:</p>
        <p>Cuiva nwalca Carnirasse; nai yarvaxea rasselya!</p>
        <p>Hneď potom zmizol.</p>
        <p>Hans a Pusheen sa teda pustili do kúzla, mysleli si že sa ten čarodejník asi zbláznil, ale niečo nie je v poriadku...</p>
    `,
    cipher: {
        images: [saruman, explosion],
    },
    continueButtonText: 'Ďalej',
};

export const step4noteIntro = {
    id: 4,
    taskText: `
        <p>Kúzlo predsa malo fungovať! Držali sme sa presne pokynov toho starého trpaslíka Yodu.</p>
        <p>Možno tie Sarumanove kúzla do toho nejako zasiahli, inak si to neviem vysvetliť.</p>
        <p>Ach to nieee.. a teraz sa všetci stratili, boli sme tak blízko.. čo len budeme robiť?</p>
        <p>Len Majky nám s tým pomôže, musíme to všetko napraviť.</p>
        <p>(Aha pozri, Sarumanovi niečo vypadlo, možno nám to pomôže odhaliť jeho plány.)</p>
    `,
    cipher: {
        images: [ohno],
    },
    continueButtonText: 'Zdvihnúť papier',
};

export const step5note = {
    id: 5,
    cipher: {
        images: [lotrcipher, dwarvish],
    },
    continueButtonText: 'Pokračujeme z denníka',
    diaryIcon: true,
};

export const step6map = {
    id: 6,
    isMap: true,
    mapPlace: 1,
    mapImage: path1,
    continueButtonText: 'Sme tu!',
};

export const step7wineryIntermission = {
    id: 7,
    cipher: {
        images: [wine],
    },
    taskText: `
        <p><strong>H:</strong> Cítim tam jemnú zemitú príchuť, a malú ovocnú stopu...</p>
        <p><strong>P:</strong> Vážne? (povedala neveriacky)</p>
        <p><strong>H:</strong> Nie :( Je to hnusné, víno asi nebude nič pre mňa, radšej si dám jabĺčko.</p>
        <p><strong>P:</strong>Ty si trdlo ...</p>
    `,
    continueButtonText: 'Ďalej',
};

export const step8winery = {
    id: 8,
    title: 'Problémy',
    taskText: `
        <p>Aha tu je, tak sme ju konečne našli. Hovorí že pôjde rada s nami, ale má problém. Rozišla sa s priateľom (zase..), a je z toho smutná. Takže si išla kúpiť víno sem, a doma si chce pustiť svoj obľúbený film, lenže sa jej všetky filmy pomiešali v obaloch.</p>
        <p>Ak jej ich pomôžeme roztriediť, pripojí sa k nám, keď si svoj film pozrie. Pomôžeš jej?</p>
    `,
    cipher: {
        images: [bridget1, bridget2],
    },
    continueButtonText: 'Ideme na to',
};

export const step9wineryProblem = {
    id: 9,
    taskText: `
        <p>Priraď správny názov filmu k scéne, ktorá sa v ňom vyskytuje.</p>
        <p>Klikni na názov filmu dole, ak si myslíš že obrázok k nemu pasuje.</p>
    `,
    diaryIcon: true,
    cipher: {
        custom: mCustomCiphers.romComs,
    },
    continueButtonText: 'Hotovo!',
};

export const step10map = {
    id: 10,
    isMap: true,
    mapPlace: 2,
    mapImage: path2,
    continueButtonText: 'Sme tu!',
};

export const step11bucky = {
    id: 11,
    title: 'Problémy',
    taskText: `
        <p>Nie, nie, nie ... čo len budem robiť? Moja kovová ruka je preč!! Určite to bol Tony, on mi nikdy neveril..Musím sa mu za to pomstiť a získať ju späť.</p>
        <p>Aha, tam v rohu je nejaká zaujímavá krabica, čo v nej môže byť? Je na nej nejaká obrazovka s kódmi hmm.. </p>
        <p>Bucky sľubuje že sa k nám pridá, ak mu ruku pomôžeme nájsť.</p>
    `,
    cipher: {
        images: [bucky1],
    },
    continueButtonText: 'Pozri sa',
};

export const step12buckyProblem = {
    id: 12,
    taskText: `
        <p>Poraď Buckymu správne odpovede a pomôž mu získať jeho ruku naspäť.</p>
        <p>Klikni na odpoveď dole ak si myslíš že je správna.</p>
    `,
    diaryIcon: true,
    cipher: {
        custom: mCustomCiphers.bucky,
    },
    continueButtonText: 'Hotovo!',
};

export const step13map = {
    id: 13,
    isMap: true,
    mapPlace: 3,
    mapImage: path3,
    continueButtonText: 'Sme tu!',
};

export const step14annabeth = {
    id: 14,
    title: 'Annabeth má problémy',
    taskText: `
        <p>Ahoj, som rada že ste tu. Boli sme tu práve na obede s Percym a ostatnými, ale zrazu sa niečo stalo!</p>
        <p>Objavil sa divný portál a všetci zmizli, len tak tak ma to do neho tiež nestiahlo. Sú odtiaľ počuť hrozné zvuky, musíme im pomôcť!.</p>
    `,
    cipher: {
        images: [annabeth, door],
    },
    continueButtonText: 'Poďme na to!',
};

export const step15janus = {
    id: 15,
    taskText: `
        <p>V prvej miestnosti sa objavil Janus, boh brán a prechodov.</p>
        <p>Je veľmi nebezpečný a v rohu drží spútanú Piper! Musíme jej pomôcť.</p>
        <p>Janus má pre nás úlohu, ak ju vyriešime, pustí nás ďalej. Ak nie, máme problém.</p>
    `,
    cipher: {
        images: [janus, piper],
    },
    continueButtonText: 'Poďme na to!',
};

export const step16januscipher = {
    id: 16,
    taskText: `
        <p>Doplň správne tabuľku.</p>
    `,
    cipher: {
        custom: mCustomCiphers.janus,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[1],
};

export const step17medusa = {
    id: 17,
    taskText: `
        <p>Výborne, Janusa sme porazili a oslobodili Piper, ale hneď v ďalšej miestnosti je ďalšie nebezpečenstvo.</p>
        <p>Hazel a Frank sú v pasci, nemôžu otvoriť oči aby mohli bojovať so zlou Medúzou.</p>
    `,
    cipher: {
        images: [meduza, hazel, frank],
    },
    continueButtonText: 'Poďme im pomôcť!',
};

export const step18medusacipher = {
    id: 18,
    taskText: `
        <p>Rozlúšti pomiešané slová a poraz Medúzu.</p>
    `,
    cipher: {
        custom: mCustomCiphers.medusa,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[2],
};

export const step19sphinx = {
    id: 19,
    taskText: `
        <p>Poraziť Medúzu po získaní kľúčového slova bola hračka a v ďalšej miestnosti sedí Sfinga.</p>
        <p>Drží 3 našich kamarátov a pustí nás za nimi len ak odpovieme správne na jej 3 hádanky.</p>
        <p>Dokážeš cez ňu prejsť?</p>
        <p>Odpovedz správne na prvú otázku aby si oslobodila Grovera!</p>
    `,
    cipher: {
        images: [sphinx, grover],
        text: 'Nemotora skoro slepý, hlína se mu na nos lepí. Pracuje i v neděli, razí v zemi tunely.',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[3],
};

export const step20sphinx = {
    id: 20,
    taskText: `
        <p>Odpovedz na druhú sfinginu otázku a osloboď Tysona.</p>
    `,
    cipher: {
        images: [tyson],
        text: 'Má sto jehel, žádnou nit. Umí dupat, ne však šít.',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[4],
};

export const step21sphinx = {
    id: 21,
    taskText: `
        <p>Posledná otázka, a tréner Hedge je voľný.</p>
    `,
    cipher: {
        images: [hedge],
        text: 'Celého tě obleču bíle jako do krupice, a když přijdeš do světnice, honem z tebe uteču.',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[5],
};

export const step22geryon = {
    id: 22,
    taskText: `
        <p>Po správnej odpovedi na všetky 3 sfingine otázky sa síce dosť naštvala, ale musela porazená ustúpiť.</p>
        <p>Oslobodila si už väčšinu kamarátov, ale stále nie si na konci labyrintu...</p>
        <p>V ďalšej miestnosti čaká nová nepríjemnosť, trojhlavý obor Geryon, ktorý je naštvaný že ste porazili jeho babičku Medúzu.</p>
        <p>Drží v pasci Jasona a jediná cesta ako ho poraziť je rozlúštiť starobylé runy na stenách, ktoré obsahujú zaklínadlo na jeho porážku.</p>
    `,
    cipher: {
        images: [geryon, jason],
    },
    continueButtonText: 'Ideme na to',
};

export const step23geryoncipher = {
    id: 23,
    taskText: `
        <p>Rozlúšti kryptické runy a poraz Geryona.</p>
    `,
    cipher: {
        custom: mCustomCiphers.geryon,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[6],
};

export const step24kalypso = {
    id: 24,
    taskText: `
        <p>Jason nám prezradil že je pred nami ešte jedna miestnosť, v ktorej drží krásna nymfa Kalypsó pod zámkom Lea.</p>
        <p>Tiež nám povedal, že ona bude vedieť kde je Percy, ktorý zmizol na začiatku a nikto nevie kam.</p>
        <p>Kalypsó je však veľmi prefíkaná, budeme ju musieť nejako poraziť, inak sa odtiaľto nikdy nedostaneme!</p>
    `,
    cipher: {
        images: [kalypso, leo],
    },
    continueButtonText: 'Ideme na to',
};

export const step25kalypsocipher = {
    id: 25,
    taskText: `
        <p>Po dlhom boji sa ti podarilo Kalypsó poraziť, ale nechce prezradiť, kde je Percy.</p>
        <p>Nakoniec sa nechala presvedčiť a nechala odkaz, ktorý obsahuje meno toho, kto Percyho drží v poslednej miestnosti.</p>
        <p>Musíš ho rozlúštiť aby ste sa mohli pripraviť na finálny súboj!</p>
    `,
    cipher: {
        custom: mCustomCiphers.kalypso,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[7],
};

export const step26hades = {
    id: 26,
    taskText: `
        <p>Takže za všetkým je Hádes, ako vždy. V poslednej miestnosti už na nás všetkých čakal.</p>
        <p>Tentokrát je to len jedna z jeho klasických hier, ktoré využíva na trápenie polobohov.</p>
        <p>Pre jeho porazenie musíme vyriešiť poslednú šifru a Percy bude voľný.</p>
        <p>V Hádovom väzení je aj jeho syn Nico, aj jeho musíme oslobodiť!</p>
    `,
    cipher: {
        images: [hades, percy, nico],
    },
    continueButtonText: 'Ideme na to',
};

export const step27hadescipher = {
    id: 27,
    taskText: `
        <p>Priraď gréckeho boha k symbolu, ktorý reprezentuje jeho schopnosti.</p>
    `,
    cipher: {
        custom: mCustomCiphers.hades,
    },
    continueButtonText: 'Hotovo',
    diaryIcon: true,
};

export const step28map = {
    id: 28,
    isMap: true,
    mapPlace: 4,
    mapImage: path4,
    continueButtonText: 'Sme tu!',
};

export const step29door = {
    id: 29,
    taskText: `
        <p>Ako tak ideš uličkou, vidíš malého chlapca, ako klopká paličkou na tehlový múr. Keď sa mu prihovoríš, zistíš že je to Neville Longbottom, a nevie sa dostať do Šikmej uličky. (ktorá sa po posledných útokoch smrťožrútov stále sťahuje, takže si nevedela že je tu). Pomôž Nevillovi dostať sa tam.</p>
        <p>Keď mu pomôžeš, pridá sa k nám.</p>    
    `,
    cipher: {
        images: [neville1],
    },
    continueButtonText: 'Idem na to',
};

export const step30door = {
    id: 30,
    taskText: `
        <p>Začni na tehle 3,4.</p>
        <p>Tri tehly doľava hore.</p>
        <p>Dve tehly doprava hore</p>
        <p>Tri tehly doprava.</p>
        <p>Jedna tehla doľava dole.</p>
        <p>Na akej si tehle?</p>
    `,
    cipher: {
        images: [wall1],
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[8],
    diaryIcon: true,
};

export const step31map = {
    id: 31,
    isMap: true,
    mapPlace: 5,
    mapImage: path5,
    continueButtonText: 'Sme tu!',
};

export const step32littleprince = {
    id: 32,
    taskText: `
        <p>
            Ale nie, my sme sa stratili, tých planétiek je tu nejako priveľa. Ale pamätám sa, že som videl jeho adresu napísanú na jednej fotke, kde ste spolu s Marošom. Len som tie fotky tak rôzne postrácal. Pomôž mi ich nájsť a priradiť ich k miestam, kde boli odfotené, možno na jednej z nich tú adresu nájdeme.
        </p>
    `,
    cipher: {
        custom: mCustomCiphers.prince,
    },
    continueButtonText: 'Hotovo',
};

export const step33littleprince = {
    id: 33,
    taskText: `
        <p>
            Konečne sme ho našli, to bolo dlhé hľadanie, tá jeho planétka je fakt ďaleko.
        </p>
        <p>
            Ale Malý Princ je nejaký smutný, čo mu asi je.. ahá jeho kamarát Zemepisec má problém, všetok svoj čas trávi v práci tvorbou máp ale nikdy neopustil svoj stôl, aby prebádal skutočný svet.
        </p>
        <p>
            Malý Princ si myslí, že by mu pomohlo, keby si našiel kamaráta, ktorý by mu ukázal skutočný svet. Pomôžeš mu? Našiel aplikáciu, ktorá je na zoznamovanie ako stvorená. Možno si tam nájde spriaznenú dušu a partnera na cestovanie.
        </p>
        <p>Poďme sem pod prístrešok, tam to lepšie uvidíme.</p>
    `,
    cipher: {
        images: [prince, geographer],
    },
    diaryIcon: true,
    continueButtonText: 'Ideme na to',
};

export const step34tinder = {
    id: 34,
    cipher: {
        custom: mCustomCiphers.tinder,
    },
};

export const step35end = {
    id: 35,
    taskText: `
        <p>
            To kúzlo vyšlo, chceli sme len aby ste spolu strávili pekný deň a robili veci čo vás bavia... Všimli sme si, že veľa lúštite rôzne šifry, a tak sme do toho zakomponovali aj vaše obľúbené postavy.
       </p>
    `,
    title: 'Koniec!',
    isMap: false,
};
